export default __webpack_public_path__ + "static/media/userlogin.bd9b415c.svg";